async function countdown() {
    const moment = (await import('moment-timezone')).default;
    let timeElement, eventTime, currentTime, duration, intervalId;

    const yearsHolder = document.getElementById('years'),
        monthsHolder = document.getElementById('months'),
        daysHolder = document.getElementById('days'),
        hoursHolder = document.getElementById('hours'),
        minutesHolder = document.getElementById('minutes'),
        secondsHolder = document.getElementById('seconds');

    if (yearsHolder) {
        const interval = 1000; // 1 second

        eventTime = moment.tz("2150-01-01T00:00:00", "America/Los_Angeles");
        currentTime = moment.tz();
        duration = moment.duration(eventTime.diff(currentTime));

        intervalId = setInterval(function () {
            duration = moment.duration(duration - interval, 'milliseconds');

            if (duration.asSeconds() <= 0) {
                clearInterval(intervalId);
                timeElement.classList.add("hidden");
            } else {
                yearsHolder.textContent = formatNumber(duration.years()) + "Y";
                monthsHolder.textContent = formatNumber(duration.months()) + "M";
                daysHolder.textContent = formatNumber(duration.days()) + "D";
                hoursHolder.textContent = formatNumber(duration.hours()) + "H";
                minutesHolder.textContent = formatNumber(duration.minutes()) + "M";
                secondsHolder.textContent = formatNumber(duration.seconds()) + "S";
            }
        }, interval);
    }

    function formatNumber(number) {
        return number < 10 ? '0' + number : number;
    }
}

export const init = countdown;